var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"f-account-t-amount",class:_vm.cClass},[(!_vm.cIsZero)?[(_vm.cReceived)?[_vm._v("+")]:[_vm._v("-")]]:_vm._e(),_c('FTMTokenValue',{attrs:{"value":_vm.amount}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }